import { Button, Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const App: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title={t('error.titleNotFound')}
      subTitle={t('error.NotFound')}
      extra={
        <Button
          type="primary"
          onClick={() => {
            history.push('/');
          }}
        >
          {t('error.backHome')}
        </Button>
      }
    />
  );
};

export default App;
